import { setShowItemDescriptionModal } from '../../../State/showItemDescriptionModal';

export default () => async (dispatch) => {

  dispatch(setShowItemDescriptionModal(true));
  
}